import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import commonUtil from '../../../../../../utils/commonUtil';
import * as defaultConst from './../../../../../../utils/clientConstant';
// import { strategy } from './../../../../../createEvent/createEventStrategy/strategy';

const applicationRoutes = commonUtil.getApplicationRoutes();

class AdministratorsDetails extends Component {
  sentenceCase = (str) => {
    if ((str === null) || (str === '')) { return false; }
    const newStr = str.toString();
    return newStr.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }

  // function for edit owner & coowner
  edit = () => {
    const celebrityInfo = this.props.celebrityInfo;
    this.props._handleEditOwnerInformation(celebrityInfo);
  }

  // function for remove coowner
  removeCoOwner = (celebrityInfo, eventID, profileId, activeEventsInfo, loggedInUserType) => {
    this.props.deleteModal(celebrityInfo, eventID, activeEventsInfo, loggedInUserType);
  }
  deleteCoOwner = (celebrityInfo, eventId, activeEventsInfo, loggedInUserType) => {
    const ownerId = celebrityInfo.repositoryId;
    // below condition for co-owner self deletion
    if (loggedInUserType === 'Co-Owner') {
      const activeEvents = Object.keys(activeEventsInfo).length;
      if (activeEvents === 0) {
        this.props.removeCoOwner(ownerId, eventId).then((response) => {
          if (response.body.status.status === defaultConst.constAPISuccess) {
            browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.home));
          }
        });
      } else if (activeEvents === 1) {
        this.props.removeCoOwner(ownerId, eventId).then((response) => {
          if (response.body.status.status === defaultConst.constAPISuccess) {
            browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: eventId }));
          }
        });
      } else if (activeEvents > 1) {
        this.props.removeCoOwner(ownerId, eventId).then((response) => {
          if (response.body.status.status === defaultConst.constAPISuccess) {
            browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.multipleEvents));
          }
        });
      }
    } else {
      this.props.removeCoOwner(ownerId, eventId).then((response) => {
        if (response.body.status.status === defaultConst.constAPISuccess) {
          this.props._getEventDetails(eventId);
        }
      });
    }
  }

  getAdminLabel = (celebrity) => {
    if (celebrity.email && celebrity.title && celebrity.celebrityLabel) {
      return <h3 className="nameAdmin">{celebrity.celebrityLabel} <span>(Administrador)</span></h3>;
    } else if (celebrity.email && celebrity.celebrityLabel && !celebrity.title) {
      return <h3 className="nameAdmin">{celebrity.celebrityLabel} <span>(Administrador)</span></h3>;
    }
    return <h3 className="nameAdmin">{celebrity.celebrityLabel}</h3>;
  }

  getAdminTitle = (celebrity) => {
    if (celebrity.email && celebrity.title && celebrity.celebrityLabel) {
      return <h3 className="nameAdmin">{celebrity.title} <span>(Administrador)</span></h3>;
    } else if (celebrity.email && celebrity.celebrityLabel && !celebrity.title) {
      return <h3 className="nameAdmin">{celebrity.celebrityLabel} <span>(Administrador)</span></h3>;
    } else if (celebrity.celebrityLabel && !celebrity.title) {
      return <h3 className="nameAdmin">{celebrity.celebrityLabel}</h3>;
    }
    return <h3 className="nameAdmin">{celebrity.title}</h3>;
  }

  render() {
    const { celebrityInfo } = this.props;
    const eventID = this.props.eventID;
    const profileId = this.props.user.result.profileId;
    const selectedEventConfiguration = this.props.selectedEventConfiguration;
    const activeEventsInfo = this.props.userEventDetails && this.props.userEventDetails.eventDetailsInfo ? this.props.userEventDetails.eventDetailsInfo.activeEventsInfo : null;
    const loggedInUserType = this.props.userEventDetails && this.props.userEventDetails.eventDetailsInfo ? this.props.userEventDetails.eventDetailsInfo.loggedInUserType : null;

    const eventStatusForSuspended = this.props.eventStatusForSuspended;
    if (eventStatusForSuspended === true) {
      let i;
      if ((document.querySelector('.darkLink')) && celebrityInfo.displayEditButton === 'true') {
        const editButton = document.querySelectorAll('.darkLink');
        for (i = 0; i < editButton.length; i++) {
          editButton[i].setAttribute('style', 'display:none');
        }
      }
      if ((document.querySelector('.deleteLink')) && celebrityInfo.displayEliminarButton === 'true') {
        document.querySelector('.deleteLink').style.display = 'none';
      }
    }

    return (
      <div className="col-sm-4" style={{ display: 'block' }}>
        {selectedEventConfiguration.showTitle ? this.getAdminTitle(celebrityInfo) : this.getAdminLabel(celebrityInfo)}
        <div className="admin">
          <span className="label">Nombre</span>
          <p>{commonUtil.sentenceCase(celebrityInfo.firstName)}</p>
          <span className="label">Apellido Paterno</span>
          <p>{commonUtil.sentenceCase(celebrityInfo.lastName)}</p>
          <span className="label">Apellido Materno</span>
          {celebrityInfo.motherName ? <p>{commonUtil.sentenceCase(celebrityInfo.motherName)}</p> : <p>-</p>}
          <span className="label">Alias</span>
          {celebrityInfo.nickName ? <p>{commonUtil.sentenceCase(celebrityInfo.nickName)}</p> : <p>-</p>}
          <span className="label">Fecha de nacimiento</span>
          {celebrityInfo.dateOfBirth ? <p>{commonUtil.sentenceCase(celebrityInfo.dateOfBirth)}</p> : <p>-</p>}
          <span className="label">Teléfono/Celular</span>
          {celebrityInfo.phone ? <p>{celebrityInfo.phone}</p> : <p>-</p>}
          <span className="label">Correo Electrónico</span>
          {celebrityInfo.email ? <p>{celebrityInfo.email}</p> : <p>-</p>}
          {celebrityInfo.displayEditButton === 'true' ? <a className="darkLink" onClick={() => this.edit()}>Editar</a> : null}
          {celebrityInfo.displayEliminarButton === 'true' ? <a className="deleteLink" onClick={() => this.removeCoOwner(celebrityInfo, eventID, profileId, activeEventsInfo, loggedInUserType)}>Eliminar</a> : null}
        </div>
      </div>
    );
  }
}

export default AdministratorsDetails;
